(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-paka"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-paka"]) return;
  try {
    
  class ProductGallery extends ModalDialog {
    constructor() {
      super();

      this.variantChange = this.variantChange.bind(this)
      this.scrollDown = this.scrollDown.bind(this)

      // DD: variant buttons
      this.buttons = this.querySelectorAll('[data-label-for]')
      Array.from(this.buttons).forEach(button => {
        button.addEventListener('click', this.variantChange)
      })

      this.downButton = this.querySelector('button.product-media-modal__down')
      this.downButton.addEventListener('click', this.scrollDown)
    }

    variantChange(e) {
      const label = e.target.closest('[data-label-for]')
      if (!label) return
      document.querySelector(`label[for=${label.dataset.labelFor}]`).click()
      this.querySelector('.product-media-modal__images').scrollTop = 0
    }

    hide() {
      super.hide();
    }

    show(opener) {
      console.log(opener)
      super.show(opener);
      this.showActiveMedia();
    }

    scrollDown(event) {
      var visibleMedia = Array.from(this.querySelectorAll('[data-media-id]')).filter((el) => !el.classList.contains('slider-image-hidden'))
      var index = visibleMedia.indexOf(this.querySelector('.active[data-media-id]'))
      if(index == visibleMedia.length - 1) index = -1
      this.openedBy = visibleMedia[index + 1]
      this.showActiveMedia()
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-gallery', ProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pakafill-table"] && !Shopify.designMode) return;
  try {
    

  const pakaFeature = document.getElementById("paka-features");
  const pakaOther = document.getElementById("others-features");
  const pakaFeatureButton = document.getElementById("paka-feature-button");
  const otherFeatureButton = document.getElementById("other-feature-button");

  pakaFeatureButton.addEventListener("click", (e) => {
    pakaFeatureButton.classList.add("active");
    otherFeatureButton.classList.remove("active");
    
    pakaFeature.classList.remove("tw-hidden");
    pakaOther.classList.add("tw-hidden");
  });

  otherFeatureButton.addEventListener("click", (e) => {
    otherFeatureButton.classList.add("active");
    pakaFeatureButton.classList.remove("active");
    
    pakaOther.classList.remove("tw-hidden");
    pakaFeature.classList.add("tw-hidden");
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-paka"] && !Shopify.designMode) return;
  try {
    
  const animationDuration = 2000
  const frameDuration = 1000 / 60
  const totalFrames = Math.round( animationDuration / frameDuration )
  const easeOutQuad = t => t * ( 2-t )

  const animateCountUp = el => {
    let frame = 0
    const countTo = parseFloat( el.innerHTML )
    const counter = setInterval( () => {
      frame++
      const progress = easeOutQuad( frame / totalFrames )

      if ( parseFloat( el.innerHTML ) === Math.floor( parseFloat (el.innerHTML ) ) ) {
        const currentCount = Math.round( countTo * progress )
        if ( parseInt( el.innerHTML ) !== currentCount ) {
          el.innerHTML = currentCount
        }
      }
      else {
        const currentCount = ( countTo * progress )
        if ( parseFloat( el.innerHTML ) !== currentCount ) {
          el.innerHTML = currentCount.toFixed(2)
        }
      }


      if ( frame === totalFrames ) {
        clearInterval( counter )
      }

    }, frameDuration )
  }

  const runAnimation = () => {
    const animatableStats = document.querySelectorAll('.stat-animate')
    animatableStats.forEach(animateCountUp)
  }


  let observedElements = document.querySelectorAll(".stat-animate")

  const options = {
    threshold: 1, //defaults to 0
    rootMargin: "0px", //default value
  }

  const inView = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        runAnimation()
      }
    })
  }

  let sectionObserver = new IntersectionObserver(inView, options)

  observedElements.forEach(function(element) {
    sectionObserver.observe(element) // run observer
  })
  

  } catch(e) { console.error(e); }
})();
})();
